import defaultAttributes from '../defaultAttributes';

const TimerReset = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M10 2h4' }],
    ['path', { d: 'M12 14v-4' }],
    ['path', { d: 'M4 13a8 8 0 018-7 8 8 0 11-5.3 14L4 17.6' }],
    ['path', { d: 'M9 17H4v5' }],
  ],
];

export default TimerReset;
